module.exports = function getResource(label, vars = []) {
    const resources = {
        checkboxContentIsModalCheckbox: 'I agree to the Beauty Insider Terms & Conditions. Rouge Reward is valid on *a future transaction only*, it *expires in 90 days*, and it will be sent via email within *24 hours*.',
        done: 'Done',
        youMustAcceptTermsConditions: 'You must accept terms and conditions first.'
    };
    return resources[label];
};
